function newInstance(option, context) {
	const el = document.createElement('div')
	const instance = new Vue({
		parent: context,
		render() {
			/*
			* 这里之所以加上 el-form disabled=false，
			* 原因是因为 设置了parent = context之后，
			* 导致lnk-mvg中的组件受到 link-mvg-input所在的el-form影响，
			* 变成默认禁用了，所以多选列也被禁用了，
			* 需要设置 lnk-form-panel 的disabled属性为false才行，这里为了优化这一步，
			* 包裹一层 el-form,并且直接设置 disabled 为false
			*/
			return (
				<el-form disabled={false}>
					<lnk-mvg{...this.binding}/>
				</el-form>
			)
		},
		data() {
			return {
				show: false,
				listener: {
					'update:show': val => this.show = val,
					'input': val => option.value = val,
					'mvg-change': changeData => {
						option.value = changeData.defaultItem;
						!!option.change && (option.change(changeData))
					}
				},
			}
		},
		computed: {
			binding() {
				return {
					props: {...option, show: this.show},
					on: this.listener,
				}
			},
		},
	})
	document.body.appendChild(el)
	instance.$mount(el)
	return instance
}

const $pick = (() => {
	let instance;
	return async (option, context) => {
		if (!!instance) {
			instance.$el.parentElement.removeChild(instance.$el)
			instance.$destroy()
		}
		instance = newInstance(option, context)
		/*
		*  element的dialog遮罩有奇怪的延迟加载问题，为了不出现一闪一闪的问题，这里加一个延迟处理
		*/
		await LinkVue.$utils.delay(200)
		instance.show = true
	}
})()


export default {
	pick: $pick,
}
